import { Component, ErrorInfo, ReactNode } from 'react';

export class ErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean; error?: Error }> {
    constructor(props: { children: ReactNode }) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error) {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('Error caught by boundary:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="w-full flex-1 font-manrope flex flex-col justify-center items-center">
                    <div className="text-[24px] mb-4 leading-[24px] font-bold text-color-base">
                        что-то пошло не так...
                    </div>
                    <div className="text-center text-base text-color-base">
                        произошла непредвиденная ошибка на этой странице. <br />
                        <button onClick={() => window.location.reload()} className="hover:underline cursor-pointer text-color-primary">Обновить страницу</button>
                    </div>
                    {this.state.error && (
                        <div className="mt-8 max-w-[720px] px-4 text-center text-xs text-color-gray break-words">
                            {this.state.error.message}
                        </div>
                    )}
                </div>
            );
        }

        return this.props.children;
    }
}